import { context } from "../typescript/interfaces";

export const FILTERS: context.Filters = {
  brandName: [],
  genericName: [],
  brandCompanies: [],
  therapeuticAreaTags: [],
  diseaseState: [],
  routesOfAdministration: [],
  mechanismsOfAction: [],
  stages: [],
  submissionTypes: [],
  fdaDesignations: [],
  launchCharacteristics: [],
  drugCharacteristics: [],
  otherAttributes: [],
  drugTypes: [],
  dateFrom: [],
  dateTo: [],
  hasDrugPipelineReport: [],
  hasHighImpactTag: [],
  isComplexMolecule: [],
  complexForms: [],
};

export const LOADING: context.Loading = {
  drugPopup: false,
  usaClinicalPipelineTearSheets: false,
};

export const THERAPEUTIC_AREA = "";

export const VISIBILITY: context.Visibility = {
  navigation: true,
  menu: false,
  stages: true,
  launchCharacteristics: true,
  drugCharacteristics: true,
  otherAttributes: true,
  detailPanelsOpen: [],
  rowsExpanded: [],
  marketing: false,
};
